import { css } from '@emotion/react'
import { Typography } from '@mui/material'

const TITLE_FONT_SIZE = 24

const noTransform = css`
  text-transform: none;
`

interface Props {
  title: string
}

export const Title = ({ title }: Props) => {
  return (
    <Typography variant="h5" fontSize={TITLE_FONT_SIZE} css={noTransform}>
      {title}
    </Typography>
  )
}
